import CryptoJS from 'crypto-js';

export function encryptToBackendFormat(data) {
  const key = 'abcdefghijklmnop';
  const iv = 'abcdefghijklmnop';
  const encryptionData = typeof data === 'object' ? JSON.stringify(data) : String(data);

  const keyUtf8 = CryptoJS.enc.Utf8.parse(key);
  const ivUtf8 = CryptoJS.enc.Utf8.parse(iv);

  const encrypted = CryptoJS.AES.encrypt(encryptionData, keyUtf8, {
    iv: ivUtf8,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  let base64 = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  return base64;
}
